import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
 
import { enWebPage, enBrowserType } from "../lib/ConstCommand";
 
import {
    sendRequestMixedClassLogin,
    setCurrentBrowserType,
    setCurrentPageType
} from "../lib/RabbitmqClient";
 
import {
    getUserListByQRLogIn,
    falseToNeedTryGetUserListAgain,
    initQrLiveInfo
} from "../modules/hiclasstv";
 
import {
    joinLive,
    requestJoinMixedClassLive,
    toggleIsNeedGoToHome
} from "../modules/live";
 
import {
    logInByQRCode,
    setLoginMessage,
    // ✅ [추가] MixedLoginContainer와 동일하게 saveTempMixedUserInfo 임포트
    // - sendRequestMixedClassLogin 전에 임시 유저 정보를 Redux에 저장하기 위해 필요
    saveTempMixedUserInfo,
    requestMixedClassLoginList,
    reqeustMixedClassLogout,
    logOut,
    forceLogOut,
    toggle_forceLogoutAlertModal
} from "../modules/user";
 
import MainContainer from "./MainContainer";
import MainAllListContainer from "./MainAllListContainer";
 
import WebContentTemplate from "../components/template/WebContentTemplate";
 
import QRLogInWindow from "../components/etc/QRLogInWindow";
import MixedClassLogInWindow from "../components/live/mixedClass/MixedClassLoginWindow";
 
class QRLogInPblContainer extends Component {
    // 20260819 QR 로그인에서 선택한 크롬북 화면 공유 방향 보정값을 라이브 이동 시까지 유지한다.
    rotateCapture = false;

    getLivePath = (liveSeq) => this.rotateCapture ? `/live/${liveSeq}?rotateCapture=-90` : `/live/${liveSeq}`;

    // 20260819 Mixed Class 자동 로그인은 선택 화면을 거치지 않으므로 크롬북의 저장 설정을 먼저 불러온다.
    initializeRotateCapture = () => {
        try {
            const userAgent = navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
            this.rotateCapture = userAgent.indexOf("cros") > -1 && window.localStorage.getItem("qrLoginRotateCapture") === "-90";
        } catch (err) {
            this.rotateCapture = false;
        }
    }
 
    // ✅ [추가] 자동 로그인 흐름 제어를 위한 state
    // - isAutoLoginTriggered: 자동 로그인(sendRequestMixedClassLogin)이 이미 호출됐는지 여부
    //   → RBMQ 연결 완료 시 JOIN을 자동으로 이어서 호출하기 위한 플래그
    // - autoLoginUserNickname: URL 쿼리에서 파싱한 닉네임을 보존
    //   → RBMQ 연결 완료 시 requestJoinMixedClassLive에 전달하기 위해 저장
    state = {
        isAutoLoginTriggered   : false,
        autoLoginUserNickname  : ""
    }
 
    // ✅ [추가] Mixed Class 멤버 목록 재요청 타이머 ID를 보관하는 인스턴스 변수
    // - setState를 쓰지 않는 이유: 타이머 ID는 렌더링에 영향을 주는 데이터가 아니므로
    //   인스턴스 변수로 관리하는 것이 적합함 (setState → 불필요한 리렌더 방지)
    // - null: 타이머가 세팅되지 않은 초기 상태
    _mixedRetryTimer = null;
 
    componentDidMount() {
        this.initializeRotateCapture();

        console.log("QRLogInPblContainer DidMount - set current browserType");
        setCurrentBrowserType(this.props.browserType);
        console.log("QRLogInPblContainer DidMount - set current pageTyle");
        setCurrentPageType(this.props.currentPageType);
 
        if (this.props.isLoginYn === "Y") {
            // 클래스 입장 후 [뒤로 가기]한 경우이므로 로그아웃 처리 ... by hjkim 20250707 (from QRLogInContainer logic ... 20220824)
            if (this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl) {
                console.log("QRLogInPblContainer(1) - have to request logOut ... userSeq => ", this.props.userSeq);
                this.props.logOut({
                    userSeq: this.props.userSeq,
                    mode: "web",
                    currentPageType: this.props.currentPageType,
                    isClickLogout: true
                });
            } else { // mixedClassPbl
                // mixedClass 입장 후 [뒤로 가기]한 경우이므로 로그아웃 처리 ... by hjkim 20250707 (from QRLogInContainer logic ... )
                console.log("QRLogInPblContainer(1) - have to request mixedClass logOut ... userSeq => ", this.props.userSeq);
                this.props.reqeustMixedClassLogout({
                    userSeq: this.props.userSeq,
                    mode: "web",
                    currentPageType: this.props.currentPageType
                });
            }
        } else {
            if (this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl) {
                // 클래스 입장 후 [뒤로 가기]한 경우 데이터 중복 요청 방지용 ... by hjkim 20250707 (from QRLogInContainer logic ... 20230403)
                if (this.props.isLoginYn === "N") {
                    if (this.props.routeProps.match && this.props.routeProps.match.params) {
                        // const liveSeq = parseInt(this.props.routeProps.match.params.liveSeq);
                        const liveSeq = this.props.routeProps.match.params.liveSeq;
                        if (liveSeq && liveSeq !== "" && parseInt(liveSeq) > 0) {
                            let mode = "web";
 
                            console.log(`QRLogInPblContainer(2) - have to request getUserListByQRLogIn ... mode[${mode}], liveSeq => `, liveSeq);
 
                            this.props.getUserListByQRLogIn({
                                liveSeq: parseInt(liveSeq),
                                mode,
                                currentPageType: this.props.currentPageType
                            });
                        } else {
                            console.log("QRLogInPblContainer(2) - can not request getUserListByQRLogIn ... liveSeq => ", liveSeq);
                        }
                    }
                }
            } else {
                // mixedClass에서 [뒤로 가기]한 경우 RBMQ 연결 및 데이터 중복 요청 방지용 ... by hjkim 20250707 (from MixedLoginContainer logic ... )
                if (!this.props.isRbmqServerConnected) {
                    const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
                    if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                        console.log("QRLogInPblContainer(3) - have to request getUserListForMixedLogin ... mixedClassSeq => ", mixedClassSeq);
                        this.props.requestMixedClassLoginList({
                            mixedClassSeq: parseInt(mixedClassSeq),
                            userKind: this.props.userKind,
                            currentPageType: this.props.currentPageType
                        });
                        // ✅ [추가] 최초 요청 후 10초 재시도 타이머 시작
                        // - 서버 응답이 없거나 list_member가 비어있는 경우를 대비
                        this._startMixedRetryTimer(parseInt(mixedClassSeq));
                    } else {
                        console.log("QRLogInPblContainer(3) - can not request getUserListForMixedLogin ... mixedClassSeq => ", mixedClassSeq);
                    }
                }
            }
        }
    }
 
    // ✅ [추가] componentWillUnmount: 컴포넌트 언마운트 시 진행 중인 재시도 타이머를 반드시 해제
    // - 언마운트 후에도 타이머 콜백이 실행되면 setState/props 접근으로 메모리 누수 및 경고 발생
    componentWillUnmount() {
        this._clearMixedRetryTimer();
    }
 
    // ✅ [추가] Mixed Class 멤버 목록 재요청 타이머 시작 헬퍼
    // - 기존 타이머가 있으면 먼저 해제(중복 방지)한 뒤 새 타이머를 등록
    // - 10초 뒤 콜백에서 list_member가 아직 비어있으면 requestMixedClassLoginList 재요청
    // - 재요청 후에는 타이머를 재귀적으로 다시 시작해 계속 재시도
    _startMixedRetryTimer = (mixedClassSeq) => {
        // 기존 타이머가 남아있으면 먼저 정리
        this._clearMixedRetryTimer();
 
        console.log("QRLogInPblContainer - mixed retry timer started ... mixedClassSeq => ", mixedClassSeq);
 
        this._mixedRetryTimer = setTimeout(() => {
            // 타이머 ID 초기화 (콜백 진입 시점에는 이미 실행된 타이머이므로 null로 리셋)
            this._mixedRetryTimer = null;
 
            // list_member가 아직 비어있는 경우에만 재요청
            // - 성공적으로 받아온 경우(_clearMixedRetryTimer로 타이머가 해제됐어야 함)는
            //   여기까지 오지 않지만, 이중 안전장치로 검사
            const currListMember = this.props.mixedClassInfo ? this.props.mixedClassInfo.list_member : null;
            if (!currListMember || currListMember.length === 0) {
                console.log("QRLogInPblContainer(9) - 10초 경과, mixed 멤버 목록 재요청 ... mixedClassSeq => ", mixedClassSeq);
                this.props.requestMixedClassLoginList({
                    mixedClassSeq,
                    userKind     : this.props.userKind,
                    currentPageType: this.props.currentPageType
                });
                // 재요청 후 타이머를 다시 시작해 계속 재시도
                this._startMixedRetryTimer(mixedClassSeq);
            } else {
                console.log("QRLogInPblContainer(9) - mixed 멤버 목록 이미 수신됨, 재시도 불필요");
            }
        }, 10000); // 10초 후 재시도
    }
 
    // ✅ [추가] Mixed Class 재시도 타이머 해제 헬퍼
    // - list_member 수신 성공 시, 또는 컴포넌트 언마운트 시 호출
    _clearMixedRetryTimer = () => {
        if (this._mixedRetryTimer !== null) {
            console.log("QRLogInPblContainer - mixed retry timer cleared");
            clearTimeout(this._mixedRetryTimer);
            this._mixedRetryTimer = null;
        }
    }
 
    shouldComponentUpdate(nextProps) {
        return (JSON.stringify(nextProps) !== JSON.stringify(this.props));
    }
 
    componentDidUpdate(prevProps) {
        if (this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl) {
            if (prevProps.isLoginYn !== this.props.isLoginYn && this.props.isLoginYn === "Y") {
                if (this.props.live_info && this.props.live_info.liveSeq > 0 && this.props.live_info.liveName && this.props.live_info.liveName !== "") {
                    console.log("QRLogInPblContainer(4) - have to request joinLive ... live_info => ", this.props.live_info);
                    this.props.joinLive({
                        liveSeq: this.props.live_info.liveSeq,
                        liveName: this.props.live_info.liveName,
                        userSeq: this.props.userSeq,
                        userNickname: this.props.userNickname,
                        profileImgUrl: this.props.profileImgUrl,
                        currentPageType: this.props.currentPageType
                    });
                } else {
                    console.log("QRLogInPblContainer(4) - can not request joinLive ... live_info => ", this.props.live_info);
                    // 강제 로그아웃 후 로그인 시도하는 경우이므로 login main 페이지로 이동
                }
            } else {
                console.log(`prevProps.isInvalidRoute[${prevProps.isInvalidRoute}], this.props.isInvalidRoute[${this.props.isInvalidRoute}]`);
                console.log(`prevProps.isNeedTryGetUserListAgain[${prevProps.isNeedTryGetUserListAgain}], this.props.isNeedTryGetUserListAgain[${this.props.isNeedTryGetUserListAgain}]`);
                // 멤버 리스트 받아오기 요청 후 리스트를 가져오지 못한 경우
                if (/* prevProps.isInvalidRoute !== this.props.isInvalidRoute &&  */this.props.isInvalidRoute) {
                    // 재요청을 시도해야하는 경우
                    if (prevProps.isNeedTryGetUserListAgain !== this.props.isNeedTryGetUserListAgain && this.props.isNeedTryGetUserListAgain) {
                        console.log("QRLogInPblContainer(8) - 타이머 생성!");
                        setTimeout(() => {
                            // 타임아웃 프록시에서 10초 후 목록 재요청
                            if (this.props.routeProps.match && this.props.routeProps.match.params) {
                                const liveSeq = this.props.routeProps.match.params.liveSeq;
                                if (liveSeq && liveSeq !== "" && parseInt(liveSeq) > 0) {
                                    let mode = "web";
 
                                    console.log(`QRLogInPblContainer(8) - have to request getUserListByQRLogIn ... mode[${mode}], liveSeq => `, liveSeq);
 
                                    this.props.getUserListByQRLogIn({
                                        liveSeq: parseInt(liveSeq),
                                        mode,
                                        currentPageType: this.props.currentPageType
                                    });
                                } else {
                                    console.log("QRLogInPblContainer(8) - can not request getUserListByQRLogIn ... liveSeq => ", liveSeq);
                                }
                            }
                        }, 10000); // 10초 후 재시도
 
                        // 우선 isNeedTryGetUserListAgain값을 다시 false로 리셋
                        console.log("QRLogInPblContainer(8) - call falseToNeedTryGetUserListAgain");
                        this.props.falseToNeedTryGetUserListAgain();
 
                        return; // 다른 프로세스 타지 않도록 반환
                    }
                }
 
                // 클래스 입장 후 [뒤로 가기]한 경우 로그아웃이 실행되기 때문에 didmount때 받아온 데이터가 모두 사라지므로 로그인 가능 목록 재호출 ... by hjkim 20250707 (from QRLogInContainer logic ... 20220824)
                if (prevProps.isLoginYn !== this.props.isLoginYn && this.props.isLoginYn === "N") {
                    if (this.props.routeProps.match && this.props.routeProps.match.params) {
                        const liveSeq = this.props.routeProps.match.params.liveSeq;
                        if (liveSeq && liveSeq !== "" && parseInt(liveSeq) > 0) {
                            let mode = "web";
 
                            console.log(`QRLogInPblContainer(5) - have to request getUserListByQRLogIn ... mode[${mode}], liveSeq => `, liveSeq);
 
                            this.props.getUserListByQRLogIn({
                                liveSeq: parseInt(liveSeq),
                                mode,
                                currentPageType: this.props.currentPageType
                            });
                        } else {
                            console.log("QRLogInPblContainer(5) - can not request getUserListByQRLogIn ... liveSeq => ", liveSeq);
                        }
                    }
                }
            }
 
            // 자동 로그인 시도
            if (prevProps.isRcvQrLoginInfo !== this.props.isRcvQrLoginInfo && this.props.isRcvQrLoginInfo) {
                if (this.props.isCanTryAutoLogin) {
                    if (this.props.routeProps && this.props.routeProps.location) {
                        if (this.props.routeProps.location.search && this.props.routeProps.location.search !== "") {
                            const query = queryString.parse(this.props.routeProps.location.search);
                            if (query && (query.userID && query.userID !== "")) {
                                const queryUserID = query.userID;
                                console.log("queryUserID => ", queryUserID);
                                // const queryUserNickname = query.userNickname;
                                // console.log("queryUserID => ", queryUserID, ", queryUserNickname => ", queryUserNickname);
                                const loginInfo = this.props.list_member.find(info => info.userID === queryUserID);
                                console.log("loginInfo => ", loginInfo);
                                if (loginInfo) {
                                    let userNickname = query.userNickname && query.userNickname !== "" ? query.userNickname : loginInfo.userNickname;
                                    console.log("userNickname => ", userNickname);
                                    this.handleSelectedFunc({
                                        selectedFunc: "LOGIN_BY_QR",
                                        loginInfo: {
                                            ...loginInfo,
                                            userNickname: userNickname
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            }
 
            if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive) {
                if (this.props.isRbmqServerConnected && this.props.performLiveSeq > -1) {
                    console.log("QRLogInPblContainer(7-1) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                    console.log("QRLogInPblContainer(7-1) - isGotoWebLive is true!!!!! go to live page!!!");
                    this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
                }
            } else {
                if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && this.props.isRbmqServerConnected) {
                    if (this.props.isGotoWebLive && this.props.performLiveSeq > -1) {
                        if (this.props.performLiveRobotLiveYN === "N") {
                            console.log("QRLogInPblContainer(7-2) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                            console.log("QRLogInPblContainer(7-2) - isGotoWebLive is true!!!!! go to live page!!!");
                            this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
                        }
                    }
                }
            }
        } else {
            // ============================================================
            // Mixed Class 케이스 (enWebPage.LiveQRLoginPbl, LiveClassTalkPbl 이외)
            // URL 예시: /pbl-mixed-login/20?userID=s1&userNickname=s1
            // ============================================================
 
            if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && this.props.isRbmqServerConnected) {
                // RBMQ 서버 연결 완료 시점
                console.log("QRLogInPblContainer(6) - temp key connected.");
                const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
                if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                    console.log("QRLogInPblContainer(6-1) - RBMQ connected for mixedClass ... mixedClassSeq => ", mixedClassSeq);
 
                    // ✅ [수정] 자동 로그인 플래그가 세팅된 경우 → JOIN 자동 실행
                    // - isAutoLoginTriggered: sendRequestMixedClassLogin 호출 후 true로 설정됨
                    // - RBMQ 연결 완료 = 임시 키 인증 완료이므로, 이 시점에 클래스 입장 요청
                    if (this.state.isAutoLoginTriggered) {
                        console.log("QRLogInPblContainer(6-1) - auto login triggered, calling JOIN ... autoLoginUserNickname => ", this.state.autoLoginUserNickname);
                        this.handleSelectedFunc({ selectedFunc: "JOIN" });
                    }
                } else {
                    console.log("QRLogInPblContainer(6-1) - can not request getUserListForMixedLogin ... mixedClassSeq => ", mixedClassSeq);
                }
            } else {
                // mixedClass에서 [뒤로 가기]한 경우 로그아웃이 실행되기 때문에 didmount때 받아온 데이터가 모두 사라지므로 로그인 가능 목록 재호출 ... by hjkim 20250707 (from MixedLoginContainer logic ... )
                if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && !this.props.isRbmqServerConnected) {
                    const mixedClassSeq = this.props.routeProps.match.params.mixedClassSeq;
                    if (mixedClassSeq && mixedClassSeq !== "" && parseInt(mixedClassSeq)) {
                        console.log("QRLogInPblContainer(6-2) - have to request getUserListForMixedLogin ... mixedClassSeq => ", mixedClassSeq);
                        this.props.requestMixedClassLoginList({
                            mixedClassSeq: parseInt(mixedClassSeq),
                            userKind: this.props.userKind,
                            currentPageType: this.props.currentPageType
                        });
                        // ✅ [추가] 뒤로 가기 후 재요청 시에도 재시도 타이머 시작
                        // - 뒤로 가기 → 로그아웃 → RBMQ 연결 해제 → list_member 초기화 경로에서도
                        //   서버 응답 실패에 대비해 동일하게 재시도 타이머를 걸어둠
                        this._startMixedRetryTimer(parseInt(mixedClassSeq));
                    } else {
                        console.log("QRLogInPblContainer(6-2) - can not request getUserListForMixedLogin ... mixedClassSeq => ", mixedClassSeq);
                    }
                }
            }
 
            // ✅ [추가] Mixed Class 자동 로그인 트리거
            // - QR 케이스의 isRcvQrLoginInfo 감지 로직과 대칭되는 로직
            // - mixedClassInfo.list_member가 새로 수신(비어있다가 데이터가 생긴 경우)될 때 실행
            // - URL 쿼리 파라미터(userID, userNickname)를 파싱해서 자동으로 로그인 처리
            const prevListMember = prevProps.mixedClassInfo ? prevProps.mixedClassInfo.list_member : null;
            const currListMember = this.props.mixedClassInfo ? this.props.mixedClassInfo.list_member : null;
 
            if (
                !this.state.isAutoLoginTriggered &&           // 아직 자동 로그인을 시도하지 않은 경우만 실행 (중복 방지)
                prevListMember !== currListMember &&           // list_member가 실제로 변경된 경우
                currListMember && currListMember.length > 0   // 새로 받은 list_member에 데이터가 있는 경우
            ) {
                // ✅ [추가] 멤버 목록 정상 수신 → 재시도 타이머 즉시 해제
                // - 타이머가 남아있는 상태에서 목록이 도착했으므로 더 이상 재시도 불필요
                this._clearMixedRetryTimer();
 
                console.log("QRLogInPblContainer - mixed class list_member received, checking auto login ...");
 
                if (this.props.routeProps && this.props.routeProps.location && this.props.routeProps.location.search && this.props.routeProps.location.search !== "") {
                    // URL 쿼리 파라미터 파싱
                    // 예: /pbl-mixed-login/20?userID=s1&userNickname=s1
                    const query = queryString.parse(this.props.routeProps.location.search);
 
                    if (query && query.userID && query.userID !== "") {
                        const queryUserID = query.userID;
                        console.log("QRLogInPblContainer - mixed auto login queryUserID => ", queryUserID);
 
                        // list_member 중에서 userID가 일치하는 멤버 탐색
                        const loginInfo = currListMember.find(info => info.userID === queryUserID);
                        console.log("QRLogInPblContainer - mixed auto login loginInfo => ", loginInfo);
 
                        if (loginInfo) {
                            // URL 쿼리에 userNickname이 있으면 우선 사용, 없으면 서버에서 받은 닉네임 사용
                            const userNickname = (query.userNickname && query.userNickname !== "")
                                ? query.userNickname
                                : loginInfo.userNickname;
 
                            console.log("QRLogInPblContainer - mixed auto login userNickname => ", userNickname);
 
                            // ✅ 자동 로그인 플래그 및 닉네임 저장
                            // - isAutoLoginTriggered: 이후 RBMQ 연결 완료 시 JOIN 자동 호출에 사용
                            // - autoLoginUserNickname: joinByQR에서 this.props.userNickname 대신 사용
                            this.setState({
                                isAutoLoginTriggered  : true,
                                autoLoginUserNickname : userNickname
                            });
 
                            // LOGIN_FOR_MIXED 핸들러 호출
                            // → saveTempMixedUserInfo + sendRequestMixedClassLogin 순서로 실행됨
                            this.handleSelectedFunc({
                                selectedFunc : "LOGIN_FOR_MIXED",
                                loginInfo    : { ...loginInfo, userNickname }
                            });
                        } else {
                            console.log("QRLogInPblContainer - mixed auto login: userID not found in list_member => ", queryUserID);
                        }
                    } else {
                        console.log("QRLogInPblContainer - mixed auto login: no userID in query string");
                    }
                } else {
                    console.log("QRLogInPblContainer - mixed auto login: no query string");
                }
            }
 
            if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive) {
                console.log("QRLogInPblContainer(7-3) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                if (this.props.isRbmqServerConnected && this.props.performLiveSeq > -1) {
                    console.log("QRLogInPblContainer(7-4) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                    console.log("QRLogInPblContainer(7-4) - isGotoWebLive is true!!!!! go to live page!!!");
                    this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
                }
            }
        }
    }
 
    handleSelectedFunc = ({ selectedFunc, live_info, loginInfo }) => {
        switch (selectedFunc) {
            case "GET_LOGIN_INFO":
                break;
 
            case "JOIN":
                this.joinByQR({ mixedClassInfo: this.props.mixedClassInfo, live_info, loginInfo });
                break;
 
            case "LOGIN_BY_QR":
                console.log(loginInfo);
                this.logInByQR(loginInfo);
                break;
 
            case "LOGIN_FOR_MIXED":
                // 20260819 수동 로그인 선택값이 있으면 저장 설정보다 우선하여 라이브 이동 주소에 반영한다.
                if (typeof loginInfo.rotateCapture === "boolean") this.rotateCapture = loginInfo.rotateCapture;
                // 20260820 Mixed 클래스 재로그인 전에 이전 로그인 오류 메시지를 초기화한다.
                this.props.setLoginMessage("", "none");

                // ✅ [수정] MixedLoginContainer의 LOGIN_FOR_MIXED와 동일하게 처리
                // - saveTempMixedUserInfo: Redux에 임시 유저 정보 저장
                //   (이후 RBMQ 연결 완료 시 userNickname 등을 참조할 수 있게 보존)
                // - sendRequestMixedClassLogin: RBMQ 임시 키 인증 요청 (userSeq 기반)
                this.props.saveTempMixedUserInfo({ loginInfo });
                sendRequestMixedClassLogin(loginInfo.userSeq);
                break;
 
            case "FORCE_LOG_OUT":
                console.log("FORCE_LOG_OUT - qr");
                this.props.forceLogOut({
                    userSeq: this.props.login_info.userSeq,
                    mode: this.props.browserType === enBrowserType.Web ? "web" : "hiclass",
                    currentPageType: this.props.currentPageType
                });
                break;
 
            case "FORCE_LOGOUT_ALERT_TOGGLE":
                this.props.toggle_forceLogoutAlertModal();
                break;
 
            default:
                break;
        }
    }
 
    logInByQR = ({ userID, userSeq, userNickname, groupSeq, list_member, groupName, rotateCapture = false }) => {
        // 20260819 크롬북 화면 공유 방향 보정 선택값을 로그인 완료 후 이동 주소에 반영한다.
        this.rotateCapture = rotateCapture;
        // 20260820 동일한 오류 메시지로 재시도해도 새 로그인 실패로 전달되도록 이전 메시지를 초기화한다.
        this.props.setLoginMessage("", "none");

        if (this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl) {
            if (userSeq >= 0) {
                console.log("QRLogInPblContainer - logInByQR => ", userSeq);
                this.props.logInByQRCode({
                    loginInfo: {
                        userSeq,
                        userNickname
                    },
                    userID,
                    userSeq,
                    userKind: this.props.userKind,
                    mode: "web",
                    kind: "qr-login",
                    currentPageType: this.props.currentPageType
                });
            } else {
                console.log("QRLogInPblContainer - logInByQR => userSeq is -1 ");
                /* if (groupSeq > -1) {
                    const liveSeq = this.props.routeProps.match.params.liveSeq;
                } */
            }
        } else {
            console.log("QRLogInPblContainer - logInByQR => currentPageType is ", this.props.currentPageType);
        }
    }
 
    joinByQR = ({ }) => {
        console.log("QRLogInPblContainer - joinByQR => currentPageType is ", this.props.currentPageType);
 
        if (this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl) {
            // QR / ClassTalk 케이스는 별도 처리 없음
        } else {
            // ✅ [수정] 자동 로그인 시 state.autoLoginUserNickname 우선 사용
            // - 자동 로그인 플래그가 세팅된 경우: URL 쿼리에서 파싱해 저장해둔 닉네임 사용
            // - 수동 로그인 케이스: 기존과 동일하게 this.props.userNickname 사용
            const userNickname = this.state.isAutoLoginTriggered && this.state.autoLoginUserNickname !== ""
                ? this.state.autoLoginUserNickname
                : this.props.userNickname;
 
            this.props.requestJoinMixedClassLive({
                liveSeq        : this.props.mixedClassInfo.liveSeq,
                liveName       : this.props.mixedClassInfo.liveName,
                userSeq        : this.props.userSeq,
                userNickname   : userNickname,
                mixedClassSeq  : this.props.mixedClassInfo.mixedClassSeq,
                currentPageType: this.props.currentPageType
            });
        }
    }
 
    render() {
        return (
            this.props.isLoginYn === "Y" && this.props.live_info.liveSeq === -1 ?
                <MainContainer
                    browserType={this.props.browserType}
                    cookies={this.props.cookies}
                    currentPageType={this.props.currentPageType}
                    routeProps={this.props.routeProps}
                >
                    <WebContentTemplate>
                        <MainAllListContainer
                            browserType={this.props.browserType}
                            cookies={this.props.cookies}
                            currentPageType={this.props.currentPageType}
                            routeProps={this.props.routeProps} />
                    </WebContentTemplate>
                </MainContainer> :
                <>
                    {
                        this.props.currentPageType === enWebPage.LiveQRLoginPbl || this.props.currentPageType === enWebPage.LiveClassTalkPbl ?
                            <QRLogInWindow
                                live_info={this.props.live_info}
                                list_member={this.props.list_member}
                                isLoginDataResolved={this.props.isRcvQrLoginResponse}
                                loginEntryFailure={this.props.loginEntryFailure}
                                alertKind={this.props.alertKind}
                                loginMessage={this.props.loginMessage}
                                isInvalidRoute={this.props.isInvalidRoute}
                                currentPageType={this.props.currentPageType}
                                handleSelectedFunc={this.handleSelectedFunc}
                            /> :
                            <MixedClassLogInWindow
                                live_info={this.props.mixedClassInfo}
                                list_member={this.props.mixedClassInfo.list_member}
                                isLoginDataResolved={this.props.isRcvMixedClassLoginResponse}
                                loginEntryFailure={this.props.loginEntryFailure}
                                alertKind={this.props.alertKind}
                                loginMessage={this.props.loginMessage}
                                isInvalidRoute={this.props.isInvalidRoute}
                                currentPageType={this.props.currentPageType}
                                handleSelectedFunc={this.handleSelectedFunc}
                            />
                    }
                </>
        );
    }
}
 
export default connect(
    ({ user, hiclasstv, live }) => ({
        isLoginYn                   : user.isLoginYn,
 
        userSeq                     : user.userSeq,
        userNickname                : user.userNickname,
        profileImgUrl               : user.profileImgUrl,
        userKind                    : user.userKind,
        mySubDomainSeq              : user.mySubDomainSeq,
 
        login_info                  : user.login_info,
 
        alertKind                   : user.alertKind,
        loginMessage                : user.loginMessage,
 
        isRbmqServerConnected       : user.isRbmqServerConnected,
 
        isNeedRetryingLogin         : user.isNeedRetryingLogin,
        isForceLogoutModalOpened    : user.isForceLogoutModalOpened,
 
        isGotoWebLive               : live.isGotoWebLive,
 
        performLiveSeq              : live.performLiveInfo.liveSeq,
        performLiveRobotLiveYN      : live.performLiveInfo.robotLiveYN,
 
        mixedClassInfo              : live.mixedClassInfo,
 
        live_info                   : hiclasstv.qrLiveInfo,
        list_member                 : hiclasstv.list_qrLoginMember,
 
        isRcvQrLoginInfo            : hiclasstv.isRcvQrLoginInfo,
        // 20260820 일반/Mixed 클래스 로그인 응답 수신 여부를 각각 전달한다.
        isRcvQrLoginResponse        : hiclasstv.isRcvQrLoginResponse,
        isRcvMixedClassLoginInfo    : live.isRcvMixedClassLoginInfo,
        isRcvMixedClassLoginResponse: live.isRcvMixedClassLoginResponse,
        loginEntryFailure           : live.loginEntryFailure,
        isCanTryAutoLogin           : hiclasstv.isCanTryAutoLogin,
        isNeedTryGetUserListAgain   : hiclasstv.isNeedTryGetUserListAgain,
        isInvalidRoute              : hiclasstv.isInvalidRoute,
    }),
    {
        getUserListByQRLogIn,
        falseToNeedTryGetUserListAgain,
        initQrLiveInfo,
 
        joinLive,
        requestJoinMixedClassLive,
 
        toggleIsNeedGoToHome,
 
        logInByQRCode,
        setLoginMessage,
        // ✅ [추가] saveTempMixedUserInfo connect dispatch 등록
        saveTempMixedUserInfo,
        requestMixedClassLoginList,
        reqeustMixedClassLogout,
 
        logOut,
        forceLogOut,
        toggle_forceLogoutAlertModal
    }
)(QRLogInPblContainer);
